import React from 'react';

// By using React.FC<React.PropsWithChildren<{}>>, you tell TypeScript:
// 1. This is a Functional Component (FC).
// 2. It accepts 'children' automatically, typed as React.ReactNode.
// 3. It has no other specific required props (hence the empty object {}).
const CardHeader: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <h2 className="text-center fw-bold mb-4">{children}</h2>
  );
};

export default CardHeader;